import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map, tap, throwError } from 'rxjs';
import { CacheService } from '../Cache/cache.service';
import { ApiService } from '../API/api.service';
import { Company, Inicialization, placeCounter, typeInterface } from 'src/app/shared/Interfaces/company';
import { environment } from 'src/environments/environment';
import { Fidelity } from 'src/app/shared/Interfaces/fidelity';
import { Cliente } from 'src/app/shared/Interfaces/customer';
import { PixelService } from '../pixel.service';
import { OrderService } from '../Order/order.service';
import { LogsService } from '../logs.service';

@Injectable({
  providedIn: 'root'
})
export class ConnectionService{


  private readonly STORAGE_KEY = 'session_id';
  private sessionId!: string;

  constructor(
    private httpClient: HttpClient,
    private cacheService: CacheService,
    private apiService: ApiService,
    private pixelService: PixelService
  ) {
    this.initSession()
  }

  //Variavel usada apenas para inicialização do Behavior
  Inicializador!: Company;
  user!: Cliente;
  fidelity!: Fidelity;
  typeParam!: typeInterface;
  urlAPI = environment.apiUrl;
  
  typeEmpty: typeInterface = {
    type: 0,
    qrCodeNumber: '',
    numberParam: 0
  }

  userEmpty!: Cliente;

  // placeEmpty: placeCounter = {
  //   id_place: '',
  //   placeName: ''
  // }

  //TYPE INTERFACE | 0 = Delivery | 1 - Mesa | 2 - Comanda | 3 - Balcão
  private typeParamSubject: BehaviorSubject<typeInterface> = new BehaviorSubject<typeInterface>(this.typeEmpty);
  public typeParam$: Observable<typeInterface> = this.typeParamSubject.asObservable();

  //Usuário
  private userSubject: BehaviorSubject<Cliente> = new BehaviorSubject<Cliente>(this.user);
  public user$: Observable<Cliente> = this.userSubject.asObservable();

  //Fidelidade
  private fidelitySubject: BehaviorSubject<Fidelity> = new BehaviorSubject<Fidelity>(this.fidelity);
  public fidelity$: Observable<Fidelity> = this.fidelitySubject.asObservable();

  //Empresa
  private companySubject: BehaviorSubject<Company> = new BehaviorSubject<Company>(this.Inicializador);
  public company$: Observable<Company> = this.companySubject.asObservable();

  //Nome da empresa
  private nameCompanySubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public nameCompany$: Observable<string> = this.nameCompanySubject.asObservable();

  //Status da Mesa/Comanda
  private permissionRequestOrderSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true)
  public permissionRequestOrder$: Observable<boolean> = this.permissionRequestOrderSubject.asObservable();

  //Modo só visualização
  private readOnlyStateSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)
  public readOnlyState$: Observable<boolean> = this.readOnlyStateSubject.asObservable();

  //Status da empresa em 1 ou 0
  private statusCompanySubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public statusCompany$: Observable<number> = this.statusCompanySubject.asObservable();

  //Redirecina para view principal
  private redirectSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public redirect$: Observable<boolean> = this.redirectSubject.asObservable();

  //Verifica o request da Empresa
  private verificationRequestSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public verificationRequest$: Observable<boolean> = this.verificationRequestSubject.asObservable();

  //Para o splash inicial
  private StopLoadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public StopLoading$: Observable<boolean> = this.StopLoadingSubject.asObservable();



  //#region Updates
  public updateType(newtype: typeInterface){
    this.typeParamSubject.next(newtype);
    this.cacheService.typeParam = newtype;
  }

  public updateStatus(newStatus: number){
    this.statusCompanySubject.next(newStatus);
  }

  public updateUser(newUser: Cliente){
    this.userSubject.next(newUser);
  }

  public updateFidelity(newFidelity: Fidelity){
    this.fidelitySubject.next(newFidelity);
  }

  public updateCompany(company: Company){
    this.companySubject.next(company);
  }

  public updateNameCompany(newName: string){
    this.nameCompanySubject.next(newName);
  }

  public updateRequestOrder(newValue: boolean){
    this.permissionRequestOrderSubject.next(newValue);
  }

  public updateReadOnly(newValue: boolean){
    this.readOnlyStateSubject.next(newValue);
  }

  public updateVerification(newValue: boolean){
    this.verificationRequestSubject.next(newValue);
  }

  public updateRedirect(newValue: boolean){
    this.redirectSubject.next(newValue)
  }

  public updateStopLoading(newValue: boolean){
    this.StopLoadingSubject.next(newValue);
  }
  //#endregion

  //Resgata todas informações da empresa
  public getCompany(nameCompany: string, typeParam: number): Observable<Inicialization>{
    let cacheCompany = '';
    let url = `${this.urlAPI}`;
    let headers;

    url += `/products/company/${nameCompany}`;

    //-------------------------
    //TYPE INTERFACE
    // 0 = Delivery
    // 1 - Mesa
    // 2 - Comanda
    // 3 - Balcão
    //-----------------------

    if(typeParam == 1 || typeParam == 2){
      headers = new HttpHeaders().set('type', '1') //MESA E COMANDA
    }
    else if(typeParam == 0){
      headers = new HttpHeaders().set('type', '2') //DELIVERY
    }
    else{
      headers = new HttpHeaders().set('type', '3') //BALCÃO
    }

    if(this.cacheService.getItemLocal('nameCompany'))
    {
      cacheCompany = this.cacheService.getItemLocal('nameCompany')
    }

    if(nameCompany != "")
    {
      if(cacheCompany != null)
      {
        if(nameCompany != cacheCompany)
        {
          this.cacheService.removeItemLocal('product-cart')
          this.cacheService.removeItemLocal('table')
          this.cacheService.removeItemLocal('Address_Saved')
        }
      }

      return this.httpClient.get<Inicialization>(url, { headers }).pipe(
      tap(data =>
      {
        const company = data.response;

        //Atualiza o Nome da empresa
        this.updateNameCompany(nameCompany);

        //Atualiza o JSON da empresa
        this.updateCompany(company);

        //Atualiza o status da empresa
        this.updateStatus(company.company.status);

        //Valida o modo visualização
        this.validationReadOnly(company, typeParam);

        //Atualiza a verificação de request feito
        this.updateVerification(true);

        //Atualiza o redirecionamento
        this.updateRedirect(false);

        //Inicia o pixel
        this.pixelService.initializePixel(company.company.pixel)

        //Seta o nome da empresa Localmente
        this.cacheService.setItemLocal('nameCompany', nameCompany);

        //Seta o nome da empresa Localmente
        this.cacheService.setItemSession('Company', company);
                              
        //Para o splash inicial
        setTimeout(() => { this.updateStopLoading(true); }, 2000);

        //Aplica as cores da Loja
        document.body.style.setProperty('--primary-color', company.configs.colorCompany);
        document.body.style.setProperty('--primary-color-alpha', company.configs.colorCompany + '33');
        document.body.style.setProperty('--color-button-positive', company.configs.colorCompany);
        document.body.style.setProperty('--color-button-negative', company.configs.colorCompany);      

      }),map(data => data));
    }
    else {
      //retorna erro e trava na pagina de splash esperando uma empresa no panametro da url
      console.log("Não foi possivel localizar empresa por favor insira uma empresa, error:", Error);

      return throwError("Erro empresa não encontrada");

    }

  }

  //valida se o cardápio é modo visualização
  public validationReadOnly(company: Company, typeParam: number){
    //-------------------------
    //TYPE INTERFACE
    // 0 = Delivery
    // 1 - Mesa
    // 2 - Comanda
    // 3 - Balcão
    //-----------------------
    if(company.configs.readOnly == 0){
      if(typeParam == 0){
        if(company.configs.deliveryReadOnly == 1){
          this.updateReadOnly(true);
        }
        else{
          this.updateReadOnly(false);
        }

      }
      else if(typeParam == 1){
        if(company.configs.localReadOnly == 1){
          this.updateReadOnly(true);
        }
        else{
          this.updateReadOnly(false);
        }
      }
      else if(typeParam == 2){
        if(company.configs.localReadOnly == 1){
          this.updateReadOnly(true);
        }
        else{
          this.updateReadOnly(false);
        }
      }
      else if(typeParam == 3){
        if(company.configs.counterReadOnly == 1){
          this.updateReadOnly(true);
        }
        else{
          this.updateReadOnly(false);
        }
      }
    }
    else{
      this.updateReadOnly(true);
    }
  }

  //Resgata as informações do usuário e as atualiza
  public getUser(id_company: string){
    const user = this.cacheService.getItemLocal('user_key')
    if(user){
      this.apiService.getUsuario(user.phone, id_company).subscribe(
        (data) =>{
          this.updateUser(data.response.customer)
          const userKey = {
            phone: data.response.customer.phone,
            id_customer: data.response.customer.id_customer,
            name: data.response.customer.name
          }
          this.cacheService.setItemLocal('user_key', userKey)

          this.getFidelity(userKey.id_customer, id_company);
        },
        (error) =>{
          console.log(error);
          if(error.status == 404)
          {
            this.cacheService.removeItemLocal('user_key')
            this.cacheService.removeItemLocal('userConfirmation');
            this.updateUser(this.userEmpty);
          }
        }
      )
    }
  }

  //Resgata as informações da Fidelidade
  public getFidelity(id_customer: string, id_company: string){
    this.apiService.getFidelity(id_customer, id_company).subscribe(
      (data) =>{
        this.updateFidelity(data)
      },
      (error) =>{
        console.log(error);
      }
    )
  }

  private initSession(): void {
    const existing = this.cacheService.getItemSession(this.STORAGE_KEY);

    if (existing) {
      this.sessionId = existing;
    } else {
      this.sessionId = this.generateUUID();
      this.cacheService.setItemSession(this.STORAGE_KEY, this.sessionId);
    }
  }

  private generateUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = crypto.getRandomValues(new Uint8Array(1))[0] % 16;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  getSessionId(): string {
    return this.sessionId;
  }

}


export { Company };

